import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class Xc47Sprayhood extends Component {
    constructor(props) {
        super(props);
        this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
        this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this);
    }
    
    handleSprayhoodChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SprayHood = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBoomCoverChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BoomCover = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view01ImageOptions;

		let image = (
			<TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2240, height: 1050 }} transform={
				[
					0.018568, 0.008687, 0, -0.000004,
					-0.001859, 0.048716, 0, -0.000021,
					0, 0, 1, 0,
					131, 292, 0, 1
				]}>
				<ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />
			</TransomConfigurator>
		);

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

					<h1><Trans defaults='Sprayhood & Boom Cover' /></h1>

					<p><Trans defaults='The standard sprayhood is supported by stainless steel framework and fittings. Whilst housed on deck covered by a canvas cover of same colour.' /></p>

					<h2><Trans defaults='Sprayhood' /></h2>
                    <MaterialSelector label={this.props.configuration.SprayHood.label} options={this.props.sprayhoodOptions} value={this.props.configuration.SprayHood} onChange={this.handleSprayhoodChange} />
                    
					<h2><Trans defaults='Boom Cover' /></h2>
                    <MaterialSelector label={this.props.configuration.BoomCover.label} options={this.props.boomCoverOptions} value={this.props.configuration.BoomCover} onChange={this.handleBoomCoverChange} />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47Sprayhood);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47Sprayhood.js